import React from "react";
import styled from "styled-components";
import { Typography } from "@material-ui/core";

const Container = styled.div`
  margin: 4px 0 4px;
  @media only screen and (min-width: 600px) {
    display: flex;
    width: 100%;
  }
`;

const Label = styled.div`
  flex: 0 0 100px;
`;

const Value = styled.div`
  flex: 0 1 auto;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
`;

export default ({ label, children }) => {
  return (
    <Container>
      <Label>
        <Typography variant="subtitle2">{label}</Typography>
      </Label>
      <Value>{children}</Value>
    </Container>
  );
};
